import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styles from "../landing.module.scss";
import { api } from "../../../utils/variables";

const PlansTable = () => {
  const [plans, setPlans] = useState([]);
  const [features, setFeatures] = useState([]);

  useEffect(() => {
    const loadPlans = async () => {
      try {
        const res = await fetch(`${api}/payments/api/products/`);
        const data = await res.json();
        const plansData = Array.isArray(data) ? data : data?.data || [];

        setPlans(plansData);

        const featureList = [];
        plansData.forEach((plan) => {
          plan.description?.forEach((f) => {
            if (!featureList.includes(f.benefit_name)) {
              featureList.push(f.benefit_name);
            }
          });
        });

        setFeatures(featureList.slice(0, Math.max(0, featureList.length - 6)));
      } catch (e) {
        console.error("Failed to load plans table", e);
      }
    };

    loadPlans();
  }, []);

  const getBenefit = (plan, feature) =>
    plan.description?.find((b) => b.benefit_name === feature);

  const formatPrice = (plan) => {
    if (plan.price === 0) return "Free";
    return `$${plan.price}/mo`;
  };


  if (!plans.length || !features.length) return null;

  return (
    <section className={styles.plansSection}>
      <div className={styles.container}>
        <div className={styles.sectionHeader}>
          <div className={styles.sectionHeaderTop}>
            <h2>Plans</h2>
            <Link
              to="/contact-us"
              className={`${styles.btn} ${styles.btnContactSales}`}
            >
              Contact Sales
            </Link>
          </div>
          <p>Start free. Upgrade when you need deeper insights.</p>
        </div>

        <div className={styles.plansContainer}>
          <table className={styles.plansTable}>
            <thead>
              <tr>
                <th>Features</th>

                {plans.map((plan) => (
                  <th
                    key={plan.id}
                    className={plan.name === "Basic" ? styles.premiumHeader : ""}
                  >
                    <div className={styles.planHeader}>
                      <span className={styles.planName}>{plan.name}</span>
                      <span className={styles.planPrice}>
                        {formatPrice(plan)}
                      </span>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {features.map((feature) => (
                <tr key={feature}>
                  <td>{feature}</td>

                  {plans.map((plan, idx) => {
                    const benefit = getBenefit(plan, feature);
                    const isPremium = idx === plans.length - 1;

                    return (
                      <td
                        key={plan.id}
                        className={isPremium ? styles.premiumValues : ""}
                      >
                        {benefit
                          ? benefit.benefit_value || "—"
                          : "Not available"}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default PlansTable;
